import { type PollsDataSource } from '../../data/polls.datasource'
import { type PollDetail } from '../models/poll.model'

export class GetPollInteractor {
  constructor(private readonly dataSource: PollsDataSource) {}

  async execute(postId: number): Promise<PollDetail | undefined> {
    const e = await this.dataSource.getByPostId(postId)
    if (!e) return undefined
    return {
      id: e.id,
      uuid: e.uuid,
      postId: e.postId,
      question: e.question,
      state: e.state,
      totalVotes: e.totalVotes,
      closesAt: new Date(e.closesAt),
      closedAt: e.closedAt ? new Date(e.closedAt) : null,
      options: e.options.map((o) => ({
        id: o.id,
        text: o.text,
        order: o.order,
        voteCount: o.voteCount
      }))
    }
  }
}
